module.exports = __webpack_public_path__ + "static/scale-model-of-thunder-road-in-fargo-north-dakota-50500fb1475ce8603b4ca4804476e928.png";